import { render, staticRenderFns } from "./NFCRoleSelectionComponent.vue?vue&type=template&id=00a47060"
import script from "./NFCRoleSelectionComponent.vue?vue&type=script&lang=js"
export * from "./NFCRoleSelectionComponent.vue?vue&type=script&lang=js"
import style0 from "./NFCRoleSelectionComponent.vue?vue&type=style&index=0&id=00a47060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports